import { createContext, PropsWithChildren, useContext } from "react";

interface LoadingStateContextValue {
  /** Whether the data required to show actions is still loading */
  isLoading: boolean;
}

/** Context that provides loading state to child components */
const LoadingStateContext = createContext<LoadingStateContextValue | null>(
  null
);

interface LoadingWrapperProps {
  /** Whether the data is loading. */
  isLoading: boolean;
}

/**
 * Wrapper component that provides loading state context to its children.
 */
export function LoadingWrapper({
  children,
  isLoading,
}: PropsWithChildren<LoadingWrapperProps>): JSX.Element {
  return (
    <LoadingStateContext.Provider value={{ isLoading }}>
      {children}
    </LoadingStateContext.Provider>
  );
}

/**
 * Hook to access the loading state context.
 * Returns `null` if used outside of the LoadingWrapper
 *
 * @returns The loading state context, or null if not within a wrapper
 */
export function useLoadingState(): LoadingStateContextValue | null {
  return useContext(LoadingStateContext);
}
